export default __webpack_public_path__ + "img/865837644df2971baedb8e6af6ddca82.svg";